import React from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';
import { nextSegment } from '../state/actions/navigationActions';
import { useDispatch, useSelector } from 'react-redux';
import { Customer } from './customer';
import { Decision } from './decision';
import { Eligibility } from './eligibility';

const segmentComponents = [Eligibility, Customer, Decision];

const getSegmentComponent = (segmentIndex) => segmentComponents[segmentIndex];

export const Segments = ({ config = [] }) => {
  const dispatch = useDispatch();
  const segmentIndex = useSelector((state) =>
    get(state, 'navigation.segmentIndex', 0)
  );
  const CurrentSegmentComponent = getSegmentComponent(segmentIndex);
  return (
    <CurrentSegmentComponent
      config={config[segmentIndex]}
      nextSegment={(values) => {
        dispatch(nextSegment(values));
      }}
    ></CurrentSegmentComponent>
  );
};

Segments.propTypes = {
  config: T.arrayOf(T.array).isRequired,
};

export default Segments;
